// @mui/icons-material
import Settings from '@mui/icons-material/Settings';
import Comment from '@mui/icons-material/Comment';
import Add from '@mui/icons-material/Add';
import Description from '@mui/icons-material/Description';

export const routes = [
  {
    user: true,
    path: '/modifier-profil',
    name: 'Modifier mon profil',
    icon: Settings,
  },
  {
    path: '/annonces',
    name: 'Mes offres',
    icon: Description,
  },
  {
    path: '/nouvelle-annonce',
    name: 'Créer une offre',
    icon: Add,
  },
  {
    path: '/messages',
    name: 'Mes messages',
    icon: Comment,
  },
  {
    path: '/charte',
    name: 'La charte VVMT',
    icon: Description,
  },
];
